<template>
  <div>
    <DefaultCard class="z-20 select-none">
      <Heading center class="mb-16">Payment Options</Heading>

      <DefaultPaymentSource/>

    </DefaultCard>
  </div>
</template>

<script>
import DefaultCard from '../layout/DefaultCard'
import Heading from '../Heading'
import DefaultPaymentSource from '@/components/common/payments/DefaultPaymentSource'

export default {
  name      : 'AccountPaymentOptions',
  components: {
    Heading,
    DefaultCard,
    DefaultPaymentSource
  },
  data () {
    return {}
  },

  created () {},

  methods: {}
}
</script>